import wbsBookingsApi from '../apis/wbsBookingsApi';

const deleteVentureAvatarsService = async (
  ventureId: string,
): Promise<void> => {
  await wbsBookingsApi.delete(`/avatars/ventures/${ventureId}`);
};

export default deleteVentureAvatarsService;
